



import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  PencilIcon,
  TrashIcon,
  ClipboardDocumentCheckIcon,
  PlusIcon,
  ArrowPathIcon,
  TrophyIcon,
  CurrencyDollarIcon,
  QrCodeIcon,
} from "@heroicons/react/24/outline";
import { deletePartner } from "../../features/admin/PartnerSlice";
import TableComponent from "../../components/TableComponent";
import PartnerModal from "../../components/admin/PartnerModal";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import PartnerApproveModal from "../../components/admin/PartnerApproveModal";
import ApiCustom from "../../utils/ApiCustom";
import PartnerCriteriaModal from "../../components/admin/PartnerCriteriaModal";
import CompanyQrModal from "../../components/admin/CompanyQrModal";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
    : [];
};

const hasPermission = (requiredPermission) => {
  const userId = localStorage.getItem("userId");
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const Partners = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [isOpenApprove, setIsOpenApprove] = useState(false);
  const [isOpenCriteria, setIsOpenCriteria] = useState(false);
  const [partners, setPartners] = useState([]);
  const userId = localStorage.getItem("userId");
  const [searchValue, setSearchValue] = useState("");
  const [representList, setRepresentList] = useState([]);
  const [qrCompany, setQrCompany] = useState(null);

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
    initData();
  };

  const handleOpenModal = (user = null) => {
    setCurrentUser(user);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentUser(null);
    initData();
  };

  const handleSubmitModal = async (data) => {
    await getPartners();
  };

  const handleCloseApprove = (check = false) => {
    setIsOpenApprove(false);
    setApprovingId(null);
    if (check) {
      initData();
      toast.success("Duyệt thành công!");
    }
  };

  const handleCloseCriteria = (check) => {
    setIsOpenCriteria(false);
    setApprovingId(null);
    if (check) {
      initData();
      toast.success("Đánh giá thành công!");
    }
  };

  const handleDelete = async () => {
    try {
      await dispatch(deletePartner(deleteId)).unwrap();
      handleCloseDeleteModal();
      toast.success("Xóa đối tác thành công!");
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi xóa đối tác!");
    }
  };

  const getUsers = () => {
    ApiCustom.get(`/user-shows`)
      .then((res) => {
        setRepresentList(res.data?.data?.data?.users);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    initData();
  }, []);

  const initData = () => {
    getUsers();
    getPartners();
  };

  const getPartners = async () => {
    ApiCustom.get("company-shows")
      .then((res) => {
        console.log(res.data.data?.data?.users);
        setPartners(res.data.data?.data?.users);
      })
      .catch((err) => console.log(err));
  };

  // const getData = async () => {
  //   ApiCustom.get("company-approved")
  //     .then((res) => {
  //       setPartners(res.data.data?.data?.users);
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const getDataByUserId = async () => {
  //   ApiCustom.get("company-show-by-user-id", {
  //     params: {
  //       userId: userId,
  //     },
  //   })
  //     .then((res) => {
  //       setPartners(res.data?.data != null ? [res.data?.data] : []);
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const getSendApprove = async () => {
  //   ApiCustom.get("company-send-approved")
  //     .then((res) => {
  //       setPartners(res.data?.data?.data?.users);
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const getNeedApprove = async () => {
  //   ApiCustom.get("company-need-approved", {
  //     params: {
  //       userId: userId,
  //     },
  //   })
  //     .then((res) => {
  //       setPartners(res.data?.data?.data?.users);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const headers = [
    {
      key: "userAvatar",
      label: "Logo",
      render: (item) => (
        <div className="w-20 h-20 rounded-lg overflow-hidden">
          {item?.userAvatar ? (
            <img
              src={item.userAvatar}
              alt={item.companyName}
              className="w-full h-full object-contain"
              loading="lazy"
            />
          ) : (
            <img
              src={`https://ui-avatars.com/api/?name=${item?.companyName}&size=200&background=random&color=fff&bold=true`}
              alt="Profile"
              className="w-full h-full object-contain"
              loading="eager"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://ui-avatars.com/api/?name=${item?.companyName}&size=200&background=random&color=fff&bold=true`;
              }}
            />
          )}
        </div>
      ),
    },
    {
      key: "companyName",
      label: "Tên đơn vị",
      render: (item) => (
        <div>
          <p className="font-medium">{item.companyName}</p>
          <p className="text-sm text-gray-500">
            {
              item?.users?.find(
                (e) => e?.CompaniesHasUsers?.isUserRepresentOfCompany
              )?.userFullName
            }
          </p>
        </div>
      ),
    },
    {
      key: "contact",
      label: "Thông tin liên hệ",
      render: (item) => (
        <div>
          <p>{item.userPhone}</p>
          <p className="text-sm text-gray-500">{item.userEmail}</p>
        </div>
      ),
    },
    {
      key: "point",
      label: "Điểm hoạt động",
    },
    {
      key: "approvalStatus",
      label: "Trạng thái",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.approvalStatus === "Đã duyệt"
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          } whitespace-nowrap`}
        >
          {item.approvalStatus}
        </span>
      ),
    },
  ];

  if (
    hasPermission("COMPANY_UPDATE") ||
    hasPermission("COMPANY_SHOW") ||
    hasPermission("COMPANY_SHOW_LIST") ||
    hasPermission("COMPANY_DESTROY") ||
    hasPermission("APPROVE_COMPANY") ||
    hasPermission("CHANGE_POINT_USER") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {
          <button
            onClick={() => handleOpenModal(item)}
            title="Chỉnh sửa"
            className="btn btn-outline btn-info btn-sm px-3 my-1 rounded"
          >
            <PencilIcon className="w-5 h-5" />
          </button>
        }
        <button
          onClick={() => setQrCompany(item)}
          title="QR doanh nghiệp"
          className="btn btn-outline btn-primary btn-sm px-3 my-1 rounded"
        >
          <QrCodeIcon className="w-5 h-5" />
        </button>
        {hasPermission("APPROVE_COMPANY") && (
          <button
            // onClick={() => handleApprove(item.id)}
            onClick={() => {
              setIsOpenApprove(true);
              setApprovingId(item.id);
            }}
            disabled={item.approvalStatus === "Đã duyệt"}
            title="Duyệt"
            className="btn btn-outline btn-accent btn-sm px-3 my-1 rounded"
          >
            {approvingId === item.id ? (
              <ArrowPathIcon className="w-5 h-5 animate-spin" />
            ) : (
              <ClipboardDocumentCheckIcon className="w-5 h-5" />
            )}
          </button>
        )}
        {hasPermission("CHANGE_POINT_USER") && (
          <button
            onClick={() => {
              setIsOpenCriteria(true);
              setApprovingId(item.id);
            }}
            title="Đánh giá tiêu chí"
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded"
          >
            <TrophyIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("COMPANY_DESTROY") && (
          <button
            onClick={() => handleOpenDeleteModal(item.id)}
            title="Xóa"
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton
          module="COMPANY"
          entityType="Company"
          entityId={item.id}
        />
      </div>
    ),
  };

  const filterData = partners?.filter((item) =>
    searchValue === ""
      ? true
      : [
          item.companyName,
          item.userFullName,
          item.userPhone,
          item.userEmail,
          item.membershipFees,
          item.approvalStatus,
        ].some((field) =>
          field?.toLowerCase().includes(searchValue.toLowerCase())
        )
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Quản lý hội viên</h1>
      </div>
      <div className="flex justify-between items-center mb-3">
        {hasPermission("COMPANY_CREATE") ? (
          <button
            onClick={() => handleOpenModal()}
            className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
          >
            <PlusIcon className="w-5 h-5" />
            <span>Thêm hội viên</span>
          </button>
        ) : (
          <div></div>
        )}
        <div className=" flex items-center space-x-2">
          <label
            htmlFor="userSearchFilter"
            className="text-sm font-medium w-24"
          >
            Tìm kiếm:
          </label>
          <input
            type="search"
            className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filterData}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <PartnerModal
          companyId={currentUser?.id || null}
          onClose={handleCloseModal}
          onSubmit={handleSubmitModal}
          representList={representList}
        />
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />

      <PartnerApproveModal
        isOpen={isOpenApprove}
        onClose={handleCloseApprove}
        id={approvingId}
      />

      <PartnerCriteriaModal
        isOpen={isOpenCriteria}
        onClose={handleCloseCriteria}
        id={approvingId}
      />

      {qrCompany && (
        <CompanyQrModal
          company={qrCompany}
          onClose={() => setQrCompany(null)}
        />
      )}
    </div>
  );
};

export default Partners;


